<template>
  <div class="block">
    <div class="block-wrap wrapBlock">
      <h2 class="h2">新闻中心</h2>
      <div class="more">
        <router-link to="/news/1" class="lookMore">查看更多<i class="el-icon-arrow-right" /></router-link>
      </div>
    </div>
    <div class="gery">
      <div class="block-wrap news_wrap">
        <div class="news_detail" :class="{ 'mobile-layout': platform === 'mobile' }">
          <div class="left">
            <div class="news-item" @click="handleToNewsDetails(newsList[0])">
              <img class="picture" :src="newsList[0]?.image" />
              <h2 class="h2">{{ newsList[0]?.title }}</h2>
              <p class="desc">{{ newsList[0]?.jieshao }}</p>
              <p class="time">{{ newsList[0]?.show_time }}</p>
            </div>
          </div>
          <div class="right">
            <div class="news-item" v-for="(item, index) in filterNewsList" :key="index" @click="handleToNewsDetails(item)">
              <!-- <img class="picture" :src="item.image" /> -->
              <h2 class="h2">{{ item.title }}</h2>
              <p class="desc">{{ item.jieshao }}</p>
              <p class="time">{{ item.show_time }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-wrap">
      <div class="video-list" :class="{ 'mobile-layout': platform === 'mobile' }">
        <div class="video-item" v-for="(item, index) in videoList" :key="index" @click="playVideo(item)">
          <div class="video-box">
            <video class="video" :src="item.url" :poster="item.image"></video>
            <div class="video-mask">
              <i class="el-icon-video-play" @click="playVideo(item)"></i>
            </div>
          </div>
          <div class="video-title">{{ item.title }}</div>
          <div class="video-desc">{{ item.jieshao }}</div>
        </div>
      </div>
      <div class="btn-more" :class="{ 'mobile-layout': platform === 'mobile' }" style="padding-top: 120px;">
        <el-button class="btn" @click="lookMore">查看更多</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="视频预览" :width="platform == 'web' ? '900px' : '100%'" center append-to-body>
      <video class="playvideo" :src="detail.url" controls="true" style="width: 100%"></video>
    </el-dialog>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      newsList: [],
      videoList: [],
      dialogVisible: false,
      detail: {},
    };
  },
  computed: {
    ...mapState(["platform"]),
    filterNewsList() {
      return this.newsList.filter((_, index) => index > 0);
    },
    isWrap() {
      if (this.platform == "mobile") {
        return false;
      } else {
        return this.type == "home";
      }
    },
  },
  created() {
    this.getNewsList();
    this.getVideoList();
  },
  methods: {
    async getNewsList() {
      const params = {
        is_shouye_show: 1,
        model_type: "news",
        limit: this.platform == "web" ? 4 : 3,
      };
      const res = await CifuAPI.getArticleList(params);
      if (res.code == 1) {
        this.newsList = res.data.data;
      }
    },
    async getVideoList() {
      const params = {
        is_shouye_show: 1,
        model_type: "news",
        is_shipin: 1,
        limit: 3,
      };
      const res = await CifuAPI.getArticleList(params);
      if (res.code == 1) {
        this.videoList = res.data.data;
      }
    },
    handleToNewsDetails(item) {
      if (item.gzh_url) {
        window.open(item.gzh_url, 'blank')
      } else {
        this.$router.push(`/newsDetail?type=0&id=${item.id}`);
      }
    },
    lookMore() {
      this.$router.push("/news/2");
    },
    playVideo(item) {
      if (item.outlink) {
        window.open(item.outlink, 'blank')
      } else {
        this.detail = item;
        this.dialogVisible = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.h2 {
  padding-bottom: 40px;
  // @media screen and (max-width: 768px) {
  //   padding-bottom: 20px;
  // }
}
.more {
  height: 50px;
  text-align: right;
  // @media screen and (max-width: 768px) {
  //   height: 30px;
  // }
}
.gery {
  background: #f4f4f4;
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }  
  @media screen and (max-width: 1400px) {
    min-width: 1400px; // 1200px以下固定宽度，不再缩小
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }  }
  
  // 只在真正的移动设备上应用移动端样式
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   position: relative;
  //   z-index: 1;
  //   min-width: auto; // 移动端不限制最小宽度
  //   &::after {
  //     position: absolute;
  //     right: -20px;
  //     top: 0;
  //     content: "";
  //     width: 20px;
  //     height: 100%;
  //     background-color: #f4f4f4;
  //   }
  //   &::before {
  //     position: absolute;
  //     left: -20px;
  //     top: 0;
  //     content: "";
  //     width: 20px;
  //     height: 100%;
  //     background-color: #f4f4f4;
  //   }
  // }
  
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }
}
.news_wrap {
  .news_tit {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    // @media screen and (max-width: 768px) {
    //   font-size: 1.2rem;
    // }
  }
  .news_detail {
    width: 100%;
    // min-width: 1300px;
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }    display: flex;
    flex-wrap: wrap;
    padding-bottom: 60px;
    
    @media screen and (max-width: 1400px) {
      min-width: 1300px; // 1200px以下固定宽度，不再缩小
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }    }
    
    // 只在真正的移动设备上应用移动端样式
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   width: 100%;
    //   padding-bottom: 20px;
    //   min-width: auto; // 移动端不限制最小宽度
    // }
    
    // 移动端布局样式
    &.mobile-layout {
      flex-direction: column;
      
      .left {
        width: 100%;
        margin-top: 0;
        margin-bottom: 20px;
        
        .news-item {
          text-align: center;
          
          .picture {
            height: 200px;
            object-fit: cover;
            border-radius: 8px;
          }
          
          .h2 {
            padding-top: 20px;
            padding-bottom: 10px;
            font-size: 18px;
            line-height: 1.4;
          }
          
          .desc {
            display: block;
            padding-bottom: 10px;
            font-size: 14px;
            line-height: 1.5;
          }
          
          .time {
            font-size: 12px;
            color: #999;
          }
        }
      }
      
      .right {
        width: 100%;
        padding-left: 0;
        
        .news-item {
          padding: 15px 0;
          border-bottom: 1px solid #f0f0f0;
          
          &:last-child {
            border-bottom: none;
          }
          
          .h2 {
            padding-top: 0;
            padding-bottom: 8px;
            font-size: 16px;
            line-height: 1.4;
          }
          
          .desc {
            display: block;
            padding-bottom: 8px;
            font-size: 14px;
            line-height: 1.5;
            color: #666;
          }
          
          .time {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
    .left {
      width: 544px;
      margin-top: -50px;
      // @media screen and (max-width: 768px) {
      //   width: 50%;
      //   margin-top: -30px;
      // }
    }
    .right {
      width: calc(100% - 544px);
      padding-left: 70px;
      // @media screen and (max-width: 768px) {
      //   width: 50%;
      //   padding-left: 10px;
      // }
      .news-item {
        border-bottom: 1px solid #bdbdbd;
      }
    }
    .news-item {
      width: 100%;
      cursor: pointer;
      .picture {
        width: 100%;
        height: 440px;
        // @media screen and (max-width: 768px) {
        //   height: auto;
        // }
      }
      .h2 {
        padding-top: 40px;
        padding-bottom: 14px;
        line-height: 28px;
        font-weight: bold;
        font-size: 24px;
        color: #663301;
        &:hover {
          color: #d60c18;
        }
        // @media screen and (max-width: 768px) {
        //   padding-top: 10px;
        //   padding-bottom: 10px;
        //   line-height: 20px;
        //   font-size: 14px;
        // }
      }
      .desc {
        padding-bottom: 12px;
        font-size: 18px;
        color: #4f4f4f;
        line-height: 24px;
        // @media screen and (max-width: 768px) {
        //   display: none;
        // }
      }
      .time {
        padding-bottom: 14px;
        font-size: 18px;
        color: #828282;
        line-height: 24px;
        // @media screen and (max-width: 768px) {
        //   font-size: 12px;
        // }
      }
    }
  }
}
.video {
  &-list {
    padding-top: 50px;
   
  }
}
.video-item{
  width: 380px;
}
.btn {
  width: 192px;
  height: 45px;
  // @media screen and (max-width: 768px) {
  //   width: 45%;
  //   height: 2rem;
  // }
}

// 移动端按钮样式
.btn-more {
  &.mobile-layout {
    padding-top: 20px !important;
    text-align: center;
    
    .btn {
      width: 100%;
      max-width: 200px;
      height: 44px;
      font-size: 16px;
      background: #fbce00;
      border-color: #fbce00;
      color: #663301;
      
      &:hover {
        background: #d60c18;
        border-color: #d60c18;
        color: #fff;
      }
    }
  }
}
.playvideo {
  width: 100%;
}
.wrapBlock {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // @media screen and (max-width: 768px) {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: normal;
  // }
}
</style>
